// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3BqSp","log":"ModalInventoryLogs_log__WxUeQ","date":"ModalInventoryLogs_date__26r64","userName":"ModalInventoryLogs_userName__2g9iu"};